import React from 'react';

import { Dialog } from '@neptune/shared/venus-ui';

export const AddOutsiderToWorkspaceAndProjectModal: React.FC<{
  isOpen: boolean;
  close: () => void;
  invitee?: string;
  onAddingConfirmed?: () => any;
}> = ({ isOpen, close, invitee, onAddingConfirmed }) => {
  if (!invitee || !onAddingConfirmed) {
    return null;
  }

  return (
    <Dialog
      isOpen={isOpen}
      title="User is not workspace member"
      primaryButtonLabel="Add user to workspace"
      primaryButtonRole="add-outsider-to-private-project-confirm"
      onPrimaryButtonClick={() => {
        onAddingConfirmed();
        close();
      }}
      secondaryButtonLabel="Cancel"
      onSecondaryButtonClick={close}
      onClose={close}
      role="add-outsider-to-private-project-modal"
    >
      <Dialog.Text>
        User {invitee} is not a member of this workspace yet. Do you want to add the user to the
        workspace?
      </Dialog.Text>
    </Dialog>
  );
};
